import { Grid, MenuItem } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';
import React from 'react';
import { useDispatch } from 'react-redux';
import { modifyAssignmentJydacomInfo } from 'store/assignments/actions/assignments.actions';

export const AssignmentCounterpartSelectItem = ({
  assignment,
  jydacomAssignmentOptions,
}) => {
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const jydacomAssignmentId = event.target.value;

    const selectedJydacomAssignment = jydacomAssignmentOptions.find(
      (assignment) => assignment.id === jydacomAssignmentId
    );

    const { code, subject, id } = selectedJydacomAssignment;

    dispatch(
      modifyAssignmentJydacomInfo({
        id: assignment.id,
        integrationNumber: code,
        integrationName: subject,
        integrationId: id,
      })
    );
  };

  return (
    <Grid
      container
      style={{
        padding: '5px 5px 5px 0px',
        width: '100%',
        borderRadius: '4px',
        marginBottom: '5px',
      }}
    >
      <Grid item xs={6} style={{ textAlign: 'center', alignContent: 'center' }}>
        <div style={{ textAlign: 'left' }}>
          {`${assignment.number}. ${assignment.name}`}
        </div>
      </Grid>

      <Grid item xs={6}>
        <TextInput
          label="Jydacom littera"
          fullWidth
          name="jydacomAssignment"
          value={assignment.integrationId || ''}
          onChange={handleChange}
          select
        >
          {jydacomAssignmentOptions
            ?.sort((a, b) => a.code - b.code)
            .map((jydacomAssignment) => (
              <MenuItem key={jydacomAssignment.id} value={jydacomAssignment.id}>
                {`${jydacomAssignment.code}. ${jydacomAssignment.subject}`}.
              </MenuItem>
            ))}
        </TextInput>
      </Grid>
    </Grid>
  );
};
